/**
 * Single source of truth for per-feature brand gradients.
 *
 * Used everywhere a "feature" needs a coloured surface — Dashboard
 * Launch X buttons, /prom landing "Inside the Pack" cards, /prom
 * <slug>/ready QR shadow, etc. Every feature MUST use these exact
 * pairs so a host's colour memory stays consistent across surfaces.
 *
 * Add new features here — never inline another gradient anywhere.
 */
export const FEATURE_GRADIENTS = {
  invites:           { from: '#B89762', to: '#B89762' },
  qr_upload:         { from: '#3B82F6', to: '#C29D52' },
  memory_guestbook:  { from: '#D946EF', to: '#B89762' },
  video_guestbook:   { from: '#26A69A', to: '#C29D52' },
  pocket_booth:      { from: '#FF0099', to: '#B89762' },
  spin_film_360:     { from: '#FF6BCB', to: '#C29D52' },
  memory_snap:       { from: '#D4AF5E', to: '#8C6A2B' },
  photo_booth:       { from: '#B89762', to: '#C29D52' },
  challenge_mode:    { from: '#B89762', to: '#FF0099' },
  full_event_film:   { from: '#A033D8', to: '#B89762' },
  highlight_reel:    { from: '#A855F7', to: '#B89762' },
  pro:               { from: '#F59E0B', to: '#EF4444' },
};

export function gradient(featureKey) {
  const g = FEATURE_GRADIENTS[featureKey];
  if (!g) return 'linear-gradient(135deg, #B89762, #C29D52)';
  return `linear-gradient(135deg, ${g.from}, ${g.to})`;
}

// Hex pair for callers that need the raw values (e.g. for translucent
// background tints or rgba shadows).
export function gradientPair(featureKey) {
  return FEATURE_GRADIENTS[featureKey] || { from: '#B89762', to: '#C29D52' };
}
